module.exports = __webpack_public_path__ + "static/media/12UNCTAD9.9c446de4.jpg";